@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.drivergroups
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.core.DateTimeDto

data class DriverGroupMembershipDto(
    val id: KmmLong?,
    val groupId: KmmLong,
    val driverId: KmmLong,
    val createdOn: DateTimeDto?
)